import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState, } from "react";
import { Form } from "../form";
import { Icon } from "../icon";
import { Flyout } from "../navigation";
import { Button } from "../button";
import { SearchWrapper, StyledWrapper, FlyoutWrapper } from "./wrapper.styles";
// utils
import { makeDataTestIdGetter } from "../utils";
export const Search = ({ onSubmit, suggestions = [], disabled, outlined, onChange, placeholder, buttonProps, name, previewId, val, dataTestIdPrefix, }) => {
    const [focused, setFocused] = useState(false);
    const [selected, setSelected] = useState(false);
    const [value, setValue] = useState(val);
    const [showFlyout, setShowFlyout] = useState(false);
    const [hoveredItemIndex, setHoveredItemIndex] = useState(-1);
    const wrapperRef = useRef(null);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    const submitForm = (item) => {
        let searchTerm = "";
        if (item) {
            searchTerm = item.content;
        }
        else if (suggestions[hoveredItemIndex]) {
            searchTerm = suggestions[hoveredItemIndex].content;
        }
        setSelected(false);
        setShowFlyout(false);
        setHoveredItemIndex(-1);
        setValue(searchTerm.trim());
        if (onSubmit) {
            onSubmit(searchTerm.trim());
        }
    };
    const onFormSubmit = (e) => {
        e.preventDefault();
        setShowFlyout(false);
        if (onSubmit) {
            onSubmit(value);
        }
    };
    useEffect(() => {
        setValue(val);
    }, [val]);
    const FlyoutElement = useMemo(() => {
        if (showFlyout && suggestions && (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0) {
            return (_jsx(FlyoutWrapper, { children: _jsx(Flyout, { initialHoveredItemIndex: hoveredItemIndex, onHoveredItemIndexChange: (itemIndex) => {
                        setHoveredItemIndex(itemIndex);
                    }, onItemChange: submitForm, inputValue: value, outlined: true, items: suggestions }) }));
        }
        return null;
    }, [showFlyout, suggestions, hoveredItemIndex]);
    const RightIcon = value ? (_jsx(Button, { onClick: () => {
            setValue("");
            setSelected(false);
            if (onChange) {
                onChange("");
            }
        }, disabled: disabled, stylingType: "flat", isIcon: true, symbol: "Close", "data-testid": getDataTestId("search-button") })) : (_jsx(Icon, { symbol: "Search", withHitSpace: true }));
    function handleButtonOnClick(e) {
        if (typeof buttonProps.onClick === "function") {
            buttonProps.onClick(e);
        }
        onFormSubmit(e);
    }
    return (_jsxs(SearchWrapper, { children: [_jsx(StyledWrapper, Object.assign({ ref: wrapperRef, disabled: disabled, tabIndex: -1, outlined: outlined, focused: focused, selected: selected || suggestions.length > 0, onMouseDown: () => {
                    setFocused(false);
                    setSelected(true);
                }, onKeyDown: (event) => {
                    if (event.key === "ArrowUp") {
                        event.preventDefault();
                        setHoveredItemIndex((i) => {
                            if (hoveredItemIndex > 0) {
                                return i - 1;
                            }
                            return suggestions.length - 1;
                        });
                    }
                    if (event.key === "ArrowDown") {
                        event.preventDefault();
                        setHoveredItemIndex((i) => {
                            if (hoveredItemIndex < suggestions.length - 1) {
                                return i + 1;
                            }
                            return 0;
                        });
                    }
                }, onKeyUp: (event) => {
                    if (event && event.key === "Tab")
                        setFocused(true);
                    if (event.currentTarget.tagName === "DIV ")
                        setSelected(true); // TODO write without tagName
                }, onBlur: () => {
                    if (selected)
                        setSelected(false);
                    if (focused)
                        setFocused(false);
                }, "data-testid": getDataTestId("search-wrapper") }, { children: _jsxs(Form, Object.assign({ previewId: previewId, onSubmit: onFormSubmit, "data-testid": getDataTestId("search-form") }, { children: [_jsx("input", { autoComplete: "off", className: name === "mainSearch" ? "main-search" : "", disabled: disabled, placeholder: placeholder, tabIndex: 0, value: value, name: name || "search", onChange: (e) => {
                                setValue(e.target.value);
                                if (e.target.value && !showFlyout) {
                                    setShowFlyout(true);
                                }
                                if (onChange) {
                                    onChange(e.target.value);
                                }
                            }, "data-testid": getDataTestId("search-form-input") }), RightIcon, FlyoutElement] })) })), buttonProps && (_jsx(Button, Object.assign({}, buttonProps, { disabled: disabled, onClick: handleButtonOnClick, stylingType: buttonProps.stylingType || "primary", size: outlined ? "standard" : "big" })))] }));
};
